import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import CalendarViewDayIcon from '@material-ui/icons/CalendarViewDay';
import onMouseResultsMap from 'src/utils/onMouseResultsMap';
import { urls } from 'src/constants';
import { useStyles, Img } from './styles';
import Button from '../../sharedComponents/CustomButtons/Button';
import { minPermisos, permitsList } from '../../../constants/permits';
import './styles.css';

const RightBar = ({
  calculos = {}, handleBigQuery, estadistica, colombia, permisos,
}) => {
  const [loading, setLoading] = useState(false);

  const handleBQ = async () => {
    setLoading(true);
    await handleBigQuery();
    setLoading(false);
  };
  const classes = useStyles();
  const name = 'Agencias';
  return (
    <Card className={classes.card}>
      <List>
        <ListItem key="Personas">
          <ListItemAvatar>
            <Avatar className={classes.large} style={{ color: 'black' }}>
              <CalendarViewDayIcon />
            </Avatar>
          </ListItemAvatar>
          <Grid item xs={12} sm={8}>
            <ListItemText primary="Personas" secondary={onMouseResultsMap.totals(calculos, 'SUM_P')} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText
              primary="Total"
              secondary={onMouseResultsMap.countZone(colombia, estadistica.zona, 'SUM_P')}
            />
          </Grid>
        </ListItem>
        <Divider />
        <ListItem key="Mobility">
          <ListItemAvatar>
            <Avatar className={classes.large}>
              <Img src={urls.LOGO_MOBILITY} />
            </Avatar>
          </ListItemAvatar>
          <Grid item xs={12} sm={8}>
            <ListItemText
              primary="Mobility"
              secondary={(
                <>
                  <Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
                    {onMouseResultsMap.totals(calculos, 'SUM_MOBILITY')}
                  </Typography>
                  {' '}
                  -
                  {' '}
                  {onMouseResultsMap.countZone(colombia, estadistica.zona, 'SUM_MOBILITY')}
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText primary={name} secondary={onMouseResultsMap.countZone(colombia, estadistica.zona, 'T_MB')} />
          </Grid>
        </ListItem>
        <Divider />
        <ListItem key="Auteco">
          <ListItemAvatar>
            <Avatar className={classes.large}>
              <Img src={urls.LOGO_AUTECO} />
            </Avatar>
          </ListItemAvatar>
          <Grid item xs={12} sm={8}>
            <ListItemText
              primary="Auteco"
              secondary={(
                <>
                  <Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
                    {onMouseResultsMap.totals(calculos, 'SUM_AUTECO')}
                  </Typography>
                  {' '}
                  -
                  {' '}
                  {onMouseResultsMap.countZone(colombia, estadistica.zona, 'SUM_AUTECO')}
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText primary={name} secondary={onMouseResultsMap.countZone(colombia, estadistica.zona, 'T_AT')} />
          </Grid>
        </ListItem>
        <Divider />
        <ListItem key="Honda">
          <ListItemAvatar>
            <Avatar className={classes.large}>
              <Img src={urls.LOGO_HONDA} />
            </Avatar>
          </ListItemAvatar>
          <Grid item xs={12} sm={8}>
            <ListItemText
              primary="Honda"
              secondary={(
                <>
                  <Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
                    {onMouseResultsMap.totals(calculos, 'SUM_HONDA')}
                  </Typography>
                  {' '}
                  -
                  {' '}
                  {onMouseResultsMap.countZone(colombia, estadistica.zona, 'SUM_HONDA')}
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText primary={name} secondary={onMouseResultsMap.countZone(colombia, estadistica.zona, 'T_HN')} />
          </Grid>
        </ListItem>
        <Divider />
        <ListItem key="Yamaha">
          <ListItemAvatar>
            <Avatar className={classes.large}>
              <Img src={urls.LOGO_YAMAHA} />
            </Avatar>
          </ListItemAvatar>
          <Grid item xs={12} sm={8}>
            <ListItemText
              primary="Yamaha"
              secondary={(
                <>
                  <Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
                    {onMouseResultsMap.totals(calculos, 'SUM_YAMAHA')}
                  </Typography>
                  {' '}
                  -
                  {' '}
                  {onMouseResultsMap.countZone(colombia, estadistica.zona, 'SUM_YAMAHA')}
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText primary={name} secondary={onMouseResultsMap.countZone(colombia, estadistica.zona, 'T_YM')} />
          </Grid>
        </ListItem>
        <Divider />
        <ListItem key="Hero">
          <ListItemAvatar>
            <Avatar className={classes.large}>
              <Img src={urls.LOGO_HERO} />
            </Avatar>
          </ListItemAvatar>
          <Grid item xs={12} sm={8}>
            <ListItemText
              primary="Hero"
              secondary={(
                <>
                  <Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
                    {onMouseResultsMap.totals(calculos, 'SUM_HERO')}
                  </Typography>
                  {' '}
                  -
                  {' '}
                  {onMouseResultsMap.countZone(colombia, estadistica.zona, 'SUM_HERO')}
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText primary={name} secondary={onMouseResultsMap.countZone(colombia, estadistica.zona, 'T_HR')} />
          </Grid>
        </ListItem>
        <Divider />
        <ListItem key="Suzuki ">
          <ListItemAvatar>
            <Avatar className={classes.large}>
              <Img src={urls.LOGO_SUZUKI} />
            </Avatar>
          </ListItemAvatar>
          <Grid item xs={12} sm={8}>
            <ListItemText
              primary="Suzuki"
              secondary={(
                <>
                  <Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
                    {onMouseResultsMap.totals(calculos, 'SUM_SUZUKI')}
                  </Typography>
                  {' '}
                  -
                  {' '}
                  {onMouseResultsMap.countZone(colombia, estadistica.zona, 'SUM_SUZUKI')}
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText primary={name} secondary={onMouseResultsMap.countZone(colombia, estadistica.zona, 'T_SZ')} />
          </Grid>
        </ListItem>
        <Divider />
        <ListItem key="AKT ">
          <ListItemAvatar>
            <Avatar className={classes.large}>
              <Img src="https://storage.googleapis.com/lucia-static.lucia.com.co/page/img/akt.jpg" />
            </Avatar>
          </ListItemAvatar>
          <Grid item xs={12} sm={8}>
            <ListItemText
              primary="AKT"
              secondary={(
                <>
                  <Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
                    {onMouseResultsMap.totals(calculos, 'SUM_AKT')}
                  </Typography>
                  {' '}
                  -
                  {' '}
                  {onMouseResultsMap.countZone(colombia, estadistica.zona, 'SUM_AKT')}
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText primary={name} secondary={onMouseResultsMap.countZone(colombia, estadistica.zona, 'T_AK')} />
          </Grid>
        </ListItem>
        <Divider />
        <ListItem key="Otras ">
          <ListItemAvatar>
            <Avatar className={classes.large}>
              <Img src="https://storage.googleapis.com/lucia-static.lucia.com.co/page/img/otros.jpg" />
            </Avatar>
          </ListItemAvatar>
          <Grid item xs={12} sm={8}>
            <ListItemText
              primary="Otras"
              secondary={(
                <>
                  <Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
                    {onMouseResultsMap.totals(calculos, 'SUM_OTROS')}
                  </Typography>
                  {' '}
                  -
                  {' '}
                  {onMouseResultsMap.countZone(colombia, estadistica.zona, 'SUM_OTROS')}
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ListItemText primary={name} secondary={onMouseResultsMap.countZone(colombia, estadistica.zona, 'T_OT')} />
          </Grid>
        </ListItem>
        <Divider />
      </List>
      {permisos[permitsList.SEGMENTACION_MAESTROS_TERRITORIOS] === minPermisos.ADMINISTATIVO ? (
        <Button type="onSubmit" onClick={() => handleBQ()} color="warning" disabled={loading}>
          {loading ? 'Consolidando...' : 'Consolidar'}
        </Button>
      ) : null}
    </Card>
  );
};

export default RightBar;
